// extracted by mini-css-extract-plugin
export default {"colocationColor":"#aa0061","developmentColor":"#e4002b","enterpriseColor":"#6e4180","button":"nQdTjRLF2n1l2PX8cJ0d","disabled":"y9gGeAPjo4tAwwMDAIng"};